import React from 'react'
import { useDispatch } from 'react-redux'
import { InsightInputsReducerI } from '../../reducers/insightReportReducer'
import { ACTIONS } from '../../../_config'

export function useInsightFilterReport() {
    const dispatch = useDispatch()

    const update = (data: InsightInputsReducerI) => {
        dispatch({
            type: ACTIONS.SET_INSIGHT_INPUTS,
            payload: data,
        })
    }

    const reset = () => {
        dispatch({
            type: ACTIONS.SET_INSIGHT_INPUTS,

            payload: {
                selectedConfig: null,
                selectedDateRange: [],
            },
        })
    }

    return { updateInsightFilter: update, resetInsightFilter: reset }
}
